module.exports = __webpack_public_path__ + "static/media/c.f4e4ce8a.svg";